import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { useLocation } from "react-router";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { setupProvisionRequestModel } from "../../../api/apiRequestObjects";
import { useSelector } from "react-redux";
import apis from "../../../api/apis";
import { APIResponseType } from "../../../config/enumApiResponseTypes";
import {
  notifyError,
  notifyServerError,
} from "../../../config/toastNotification";
import LoadingComponent from "../../loadingComponent/LoadingComponent";
import { Fade, Spinner } from "reactstrap";
import LoadingButton from "@mui/lab/LoadingButton";

// styles
import styles from "./ProvisionSetupButton.module.scss";
import { ToastContainer } from "react-toastify";

//manual close button for toast notifications
const CloseButton = ({ closeToast }: any) => (
  <i
    className="material-icons"
    onClick={closeToast && window.location.reload()}
  ></i>
);

interface IProps {
  handleGetStores: () => void;
}

let initialLoaded = false;

const ProvisionSetupButton: React.FC<IProps> = ({ handleGetStores }) => {
  //const [isCodeAvailable, setIsCodeAvailable] = useState(false);
  const [isProvisioned, setIsProvisioned] = useState(false);
  //const [singleAuthCode, setSingleAuthCode] = useState("");
  //const [typedValue, setTypedValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [urlCopied, setUrlCopied] = useState("");
  //const [isValidEmail, setIsValidEmail] = useState(true);
  //const [mailSent, setMailSent] = useState(true);

  const [openDialog, setOpenDialog] = React.useState(false);

  //get redux state
  const { user } = useSelector((state: any) => state.authentication);

  /*   const handleProvisioning = async () => {
    let emailValidatingRegExp =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailValidatingRegExp.test(typedValue)) {
      setIsValidEmail(true);
      setIsLoading(true);
      setupProvisionRequestModel.UID.UserKey = user.UserKey;
      setupProvisionRequestModel.UID.LocationKey = user.LocationKey;
      setupProvisionRequestModel.UID.CompanyKey = user.CompanyKey;
      setupProvisionRequestModel.EmailAddress = typedValue;

      const response = await apis.Provisions.setupProvision(
        setupProvisionRequestModel
      );

      if (response.ResponseType === APIResponseType.Success) {
        setIsLoading(false);
        setMailSent(true);
      } else {
        setIsLoading(false);
        notifyError();
        //console.log(response);
      }
    } else {
      setIsValidEmail(false);
    }
  }; */

  /*  const handleTypedEmail = (e: any) => {
    setTypedValue(e.target.value);
  }; */

  const handleGeneratingLinkClick = async () => {
    setIsLoading(true);
    setupProvisionRequestModel.UID.UserKey = user.UserKey;
    setupProvisionRequestModel.UID.LocationKey = user.LocationKey;
    setupProvisionRequestModel.UID.CompanyKey = user.CompanyKey;
    setupProvisionRequestModel.UID.EnvironmentName = user.EnvironmentName;

    const response = await apis.Provisions.setupProvision(
      setupProvisionRequestModel
    );

    if (response.ResponseType === APIResponseType.Success) {
      setIsLoading(false);
      navigator.clipboard.writeText(response.Messages[0].Message);
      setUrlCopied(response.Messages[0].Message);
    } else {
      setIsLoading(false);
      //console.log(response);
    }
  };

  const handleClickDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  //const currentUri = useLocation();

  useEffect(() => {
    const fetchIsUberProvisionedData = async () => {
      try {
        setIsLoading(true);
        setupProvisionRequestModel.UID.UserKey = user.UserKey;
        setupProvisionRequestModel.UID.LocationKey = user.LocationKey;
        setupProvisionRequestModel.UID.CompanyKey = user.CompanyKey;
        setupProvisionRequestModel.UID.EnvironmentName = user.EnvironmentName;

        const response = await apis.Provisions.isUberProvisioned(
          setupProvisionRequestModel
        );

        if (response.ResponseType === APIResponseType.Success) {
          setIsLoading(false);
          setIsProvisioned(true);
        } else {
          setIsLoading(false);
          setIsProvisioned(false);
          //notifyError();
          //console.log(response);
        }
      } catch (e) {
        setIsLoading(false);
        notifyServerError();
        console.log(e);
      }
    };

    if (!isProvisioned) {
      fetchIsUberProvisionedData();
    }
    //fetchIsUberProvisionedData();
  }, [isProvisioned, user?.CompanyKey, user?.LocationKey, user?.UserKey]);

  if (!isProvisioned)
    return (
      <>
        <Button
          variant="outlined"
          startIcon={<BusinessCenterOutlinedIcon />}
          onClick={handleClickDialogOpen}
        >
          Setup Provisioning
        </Button>
        <Dialog open={openDialog} onClose={handleDialogClose}>
          <DialogTitle>Copy Provision Setup Link</DialogTitle>
          {/*           <DialogContent>
          <DialogContentText>
              To integrate your uber stores to our BLX OrderHub, please enter
              your email address here. We will send you a link to follow the
              integration process.
            </DialogContentText> */}
          {/*             <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Email Address"
              type="email"
              fullWidth
              variant="standard"
              value={typedValue}
              onChange={handleTypedEmail}
              helperText={
                isValidEmail ? "" : "Please enter valid e-mail address"
              }
              error={!isValidEmail}
            />
          </DialogContent> */}
          <DialogActions>
            <Button onClick={handleDialogClose}>Cancel</Button>
            <LoadingButton
              disabled={urlCopied !== "" ? true : false}
              onClick={handleGeneratingLinkClick}
              loading={isLoading}
              loadingIndicator="Generating Link ..."
              variant="outlined"
            >
              {urlCopied !== "" ? "Link Copied to Clipboard" : "Copy Link"}
            </LoadingButton>
            {/*             {!isLoading && !mailSent && (
              <Button
                onClick={handleProvisioning}
                disabled={typedValue !== "" ? false : true}
              >
                Send
              </Button>
            )} */}
            {/*             {mailSent && (
              <Fade in={mailSent} tag="h5" className={styles.fade_msg}>
                Success ✅
              </Fade>
            )} */}
            {isLoading && <Spinner children="" type="grow" color="primary" />}
          </DialogActions>
        </Dialog>
        {/*         <ToastContainer
          className={styles.toast_notifier}
          closeButton={CloseButton}
        /> */}
      </>
    );

  if (isProvisioned)
    return (
      <Button
        variant="outlined"
        startIcon={<StorefrontIcon />}
        onClick={() => handleGetStores()}
      >
        Get Stores
      </Button>
    );

  if (isLoading) return <LoadingComponent />;

  return null;
};

export default ProvisionSetupButton;
